import baseAxios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { LocalStorageService } from '.';
import { config } from '../config';

const CancelToken = baseAxios.CancelToken.source();
const isCancel = baseAxios.isCancel;
const axios = baseAxios.create();

const isTokenExpired = (expTime) => {
  try {
    return expTime <= new Date().getTime();
  } catch (err) {
    return false;
  }
};

const onRequest = async (config: AxiosRequestConfig, getAccessTokenSilently:any = null): Promise<AxiosRequestConfig> => {
  // console.log('onRequest', {config})
  let token = LocalStorageService.getItem('ACCESS_TOKEN'); //await getAccessTokenSilently();
  const expTime = LocalStorageService.getItem('ACCESS_TOKEN_EXPIRE');
  if (isTokenExpired(expTime) && getAccessTokenSilently != 'system') {
    token = await getAccessTokenSilently();
    LocalStorageService.setItem('accessToken', token);
    const nextAccessTokenRenewTime = new Date(Date.now() + 1000 * 60 * 4).getTime();
    LocalStorageService.setItem('ACCESS_TOKEN_EXPIRE', nextAccessTokenRenewTime);
  } 
  config.headers.Authorization = `Bearer ${token}`;
  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  // console.log('onRequestError', {error});
  return Promise.reject(error);
};
const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const onResponseError = async (error: AxiosError): Promise<AxiosError> => {
  // console.log('onResponseError', { error });
  if (error.response) {
    // Access Token was expired
    if (error.response.status === 401) {
      try {
        if (error.response && error.response.data === 'You cannot use this model without logging in!') {
          return error;
        }
      } catch (_error) {
        return Promise.reject(_error);
      }
    } else if (error.response.status === 400 || error.response.status === 404) {
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
};

const setupInterceptorsTo = (axiosInstance: AxiosInstance): AxiosInstance => {
    // axiosInstance.interceptors.request.use(onRequest, onRequestError);
    axiosInstance.interceptors.response.use(onResponse, onResponseError);
    return axiosInstance;
  };

  const httpClient = setupInterceptorsTo(
    baseAxios.create({
      baseURL: config.apiBaseUrl,
    })
  );

  const httpClientForImage = setupInterceptorsTo(
    baseAxios.create({
      baseURL: 'https://uptpt.dev.unitypredict.net',
    })
  );
  const setAxiosTokenInterceptor = async (getAccessTokenSilently) => {
    try {
  
      httpClient.interceptors.request.use((config) => onRequest(config, getAccessTokenSilently), onRequestError);
      httpClientForImage.interceptors.request.use((config) => onRequest(config, getAccessTokenSilently), onRequestError);
      httpClient.interceptors.response.use(onResponse, onResponseError);
      httpClientForImage.interceptors.response.use(onResponse, onResponseError);
    
    
    } catch (error) {
      // catching the login required error which we can safely ignore here
      console.error('Unable to get access token due to', {error});
    }
  };

  export {
   
    axios,
    CancelToken,
    baseAxios,
    httpClient,
    httpClientForImage,
    isCancel,
    setAxiosTokenInterceptor
  };